import React from 'react';
import {Avatar} from "antd";
import {getUserInitials, getAvatarSrc} from "../helpers/functions";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";

const UserAvatar = (props) => {
    const { user, nameType, disabled, hideAvatar } = props;
    const name = nameType === 'full' ? user.full_name : nameType === 'firstName' ? user.first_name : '';

    return (
        <span style={{display: 'flex', alignItems: 'center', gap: hideAvatar ? 0 : '10px', minWidth: 0, maxWidth: '100%', overflow: 'hidden'}}>
            {!hideAvatar &&
                <Avatar size={30} src={getAvatarSrc(user)} style={{backgroundColor: Colors.weekDayDark, fontSize: '14px', opacity: disabled ? '50%' : '100%', border: '1px solid white', flexShrink: 0}}>{getUserInitials(user)}</Avatar>
            }
            <span style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', opacity: disabled ? '50%' : '100%'}}>{name}</span>
        </span>
    );
};

export default UserAvatar;